import api from "./axios";

export interface ProductDto {
  id: number;

  categoryId: number | null;

  nameRu: string;
  nameKz: string;
  kzReviewed?: boolean;

  descriptionRu: string | null;
  descriptionKz: string | null;

  salePrice: number;

  type: "product" | "service" | "software";

  warrantyMonths: number | null;

  availableTemirtau: boolean;
  availableKaraganda: boolean;

  imageUrl: string | null;

  sku: string | null;
  barcode: string | null;
  brand: string | null;
  model: string | null;

  isActive: boolean;

  oldPrice: number | null;
  subscriptionPeriod: string | null;
  devicesCount: number | null;
  licenseType: string | null;
  badge: string | null;
  isFeatured: boolean;

  // 🔥 ВАЖНО: теперь это число, а не объект
  stock: number | null;

  downloadLink: string | null;
  purchasePrice: number | null;
  unit: string | null;
  isMontProduct: boolean;
  requireSerial?: boolean;
  kaspiEnabled?: boolean;
  kaspiSku?: string | null;
  externalSkus: string[];
}

function mapToBackend(payload: Partial<ProductDto>) {
  return {
    nameRu: payload.nameRu,
    nameKz: payload.nameKz,
    kzReviewed: payload.kzReviewed,

    descriptionRu: payload.descriptionRu,
    descriptionKz: payload.descriptionKz,

    salePrice: payload.salePrice,
    type: payload.type,

    warrantyMonths: payload.warrantyMonths,

    availableTemirtau: payload.availableTemirtau,
    availableKaraganda: payload.availableKaraganda,

    imageUrl: payload.imageUrl,

    sku: payload.sku,
    barcode: payload.barcode,
    brand: payload.brand,
    model: payload.model,

    categoryId: payload.categoryId,
    isActive: payload.isActive,

    oldPrice: payload.oldPrice ?? null,
    subscriptionPeriod: payload.subscriptionPeriod ?? null,
    devicesCount: payload.devicesCount ?? null,
    licenseType: payload.licenseType ?? null,
    badge: payload.badge ?? null,
    isFeatured: payload.isFeatured ?? false,
    downloadLink: payload.downloadLink ?? null,
    purchasePrice: payload.purchasePrice ?? null,
    isMontProduct: payload.isMontProduct ?? false,
    requireSerial: payload.requireSerial,
    kaspiEnabled: payload.kaspiEnabled,
    kaspiSku: payload.kaspiSku,
    externalSkus: payload.externalSkus ?? [],
  };
}

export async function getProducts(): Promise<ProductDto[]> {
  const res = await api.get<ProductDto[]>("/products");
  return res.data;
}

export async function getProductsByCategory(categoryId: number): Promise<ProductDto[]> {
  const res = await api.get<ProductDto[]>(`/products/category/${categoryId}`);
  return res.data;
}

export async function getProductsByFolder(folderId: number): Promise<ProductDto[]> {
  const res = await api.get<ProductDto[]>(`/products?folderId=${folderId}`);
  return res.data;
}

export async function createProduct(payload: Partial<ProductDto>) {
  const dto = mapToBackend(payload);
  const res = await api.post<ProductDto>("/products", dto);
  return res.data;
}

export async function updateProduct(id: number, payload: Partial<ProductDto>) {
  const dto = mapToBackend(payload);
  // Удаляем только undefined (не null — null нужен для очистки полей)
  Object.keys(dto).forEach(key => {
    if ((dto as any)[key] === undefined) delete (dto as any)[key];
  });
  const res = await api.put<ProductDto>(`/products/${id}`, dto);
  return res.data;
}

export async function deleteProduct(id: number) {
  const res = await api.delete<void>(`/products/${id}`);
  return res.data;
}

export async function uploadProductImage(file: File): Promise<string> {
  const form = new FormData();
  form.append("file", file);

  const res = await api.post("/products/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  const data = res.data;

  if (typeof data === "string") return data;
  if (data.url) return data.url;
  if (data.path) return data.path;
  if (data.imageUrl) return data.imageUrl;

  throw new Error("Invalid upload response");
}
